exports = module.exports = require("../../node_modules/@hypertype/tools/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ctx-tree {\n  display: block;\n}\n", ""]);

